export default "__VITE_ASSET__BV0jja7a__"